import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Textarea } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

const RekomendasiPenerimaInfo = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'rekomendasiPenerimaInfo-1',
    })

    const [data, setData] = React.useState({
        modalShow: false,
        modalValue: '',
        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = () => {
        setData(d => ({
            ...d,
            submitLoading: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_barang_rekomendasi_penerima_info', data.modalValue);

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_rekomendasi_penerima_info',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false, modalShow: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(data.modalValue);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false,
                modalShow: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <Textarea
                value={stateData.data.value}
                readOnly={true}
                minRows={3}
                maxRows={4}
                onClick={() =>
                    setData(d => ({
                        ...d,
                        modalShow: true,
                        modalValue: stateData.data.value
                    }))
                }

                styles={(tema) => ({
                    input: {
                        backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                    }
                })}

                label={stateData.data.label}
                placeholder={stateData.data.placeholder}
                error={stateData.data.error}
                description={stateData.data.description}
                withAsterisk={stateData.data.withAsterisk}
            />

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.modalShow}
                fnHide={() => setData(d => ({ ...d, modalShow: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Catatan Rekomendasi').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.submitLoading}
                fnButtonAction={submitData}
            >
                <Textarea
                    value={data.modalValue}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) =>
                        setData(d => ({
                            ...d,
                            modalValue: e.target.value
                        }))
                    }

                    label=''
                    placeholder='Catatan / Keterangan Rekomendasi'
                    error=''
                    description=''
                    withAsterisk={false}
                />
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default RekomendasiPenerimaInfo;